import { Icon } from '@chakra-ui/react';
import { chartColor } from './TimeSeriesChart';

const DISK = 'M8 1.75a6.25 6.25 0 1 1 0 12.5a6.25 6.25 0 1 1 0-12.5z';
const HALF = 'M8 4.25a3.75 3.75 0 0 1 0 7.5z';

// Linear's status circles, read for statements: a full disc is done, a half
// is under way, a ring with "!" needs attention, a dashed ring has nothing yet.
const GLYPHS = {
  up_to_date: { ring: 'redesign.accent.green', fill: DISK, mark: 'M5.4 8.1l1.8 1.8 3.4-3.7', markColor: 'redesign.bg.surface' },
  behind: { ring: 'redesign.accent.amber', fill: HALF },
  outdated: { ring: 'redesign.accent.red', mark: 'M8 4.9v3.6 M8 11v.05', markColor: 'redesign.accent.red' },
  none: { ring: 'redesign.text.muted', dashed: true },
};

/**
 * A statement status as a small glyph. Decorative: the label beside it says
 * the status in words.
 */
export default function StatusGlyph({ status, boxSize = '14px' }) {
  const g = GLYPHS[status] || GLYPHS.none;
  return (
    <Icon viewBox="0 0 16 16" boxSize={boxSize} flexShrink={0} aria-hidden="true">
      <circle
        cx="8" cy="8" r="6.25" fill="none"
        stroke={chartColor(g.ring)} strokeWidth="1.5"
        strokeDasharray={g.dashed ? '2.1 2.1' : undefined}
      />
      {g.fill && <path d={g.fill} fill={chartColor(g.ring)} />}
      {g.mark && (
        <path d={g.mark} fill="none" stroke={chartColor(g.markColor)} strokeWidth="1.6"
              strokeLinecap="round" strokeLinejoin="round" />
      )}
    </Icon>
  );
}
